import React, { useEffect, useState } from "react";
import { SubmitRule } from "../fields";
import CompanyTeamsRule from "../fields/CompanyTeamsRule/CompanyTeamsRule";
import { NameRule } from "../fields/NameRule";
import { UsersRule } from "../fields/UsersRule";

function ByRescueUser({
  users,
  teams,
  handleSubmit,
  distribution_type,
  company_id,
  rule,
}) {
  const [errors, setErrors] = useState({});
  const [attributes, setAttributes] = useState({
    name: rule.name || "",
    routing: rule.routing || "",
    users: rule.user_ids || [],
    conditionals: rule.conditionals || {},
    company_teams: rule.company_team_ids || [],
  });

  useEffect(() => {
    const attributesErrors = {};

    if (attributes.users.length == 0 && attributes.company_teams.length == 0) {
      attributesErrors.usersOrCompanyTeam =
        "Necessário ao menos um usuário ou uma equipe selecionada";
    }

    if (!attributes.name) {
      attributesErrors.name = "Campo obrigatório";
    }

    setErrors(attributesErrors);
  }, [attributes]);

  function handleClick(e) {
    e.preventDefault();

    const data = {
      rule: {
        name: attributes.name,
        company_id: company_id,
        priority: rule.priority || 99,
        distribution_type: distribution_type,
        routing: "RoundRobin",
        user_ids: attributes.users,
        company_team_ids: attributes.company_teams,
      },
    };

    handleSubmit(data);
  }

  return (
    <>
      <div
        style={{
          marginTop: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <NameRule
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
        />

        <CompanyTeamsRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          teams={teams}
        />

        <UsersRule
          rule={rule}
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
          users={users}
        />

        <SubmitRule
          disabled={Object.keys(errors).length > 0}
          handleClick={handleClick}
          rule={rule}
        />
      </div>
    </>
  );
}

export default ByRescueUser;
